var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.myShow && !_vm.timmedOut )?_c('div',{staticClass:"alert myAlert fadeIn text-center"},[_vm._v("\n  "+_vm._s(_vm.myMessage)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }